module.exports = __webpack_public_path__ + "static/historia_os-8548bcb3ec52bdd382ce97be56602c02.jpg";